import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { EavAttributeValueTypeEnum } from '@zaoblako/shared/modules/eav/enums/eav-attribute-value-type.enum';
import { EavAttributeValueTypeEnumI18n } from '@zaoblako/shared/modules/eav/i18n/eav-attribute-value-type-enum.i18n';

@Pipe({
  name: 'eavAttributeValueTypeName',
  standalone: true
})
export class EavAttributeValueTypeNamePipe implements PipeTransform {
  public transform(type: EavAttributeValueTypeEnum): string {
    return EavAttributeValueTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
